import * as A from 'fp-ts/Array'
import { pipe } from 'fp-ts/lib/function'
import * as t from 'io-ts'

import { Potential_Property_Media } from '@/types/cate-graphql-generated-types'

const floorPlanType = t.type({
  url: t.string,
})

export const cardPhotos = t.type({
  isPrimary: t.boolean,
  url: t.string,
})

export type CardPhotoType = t.TypeOf<typeof cardPhotos>
export type PriorityMedia = {
  floorPlan: {
    url: string
  }[]
  photoGallery: {
    isPrimary: boolean
    url: string
  }[]
}

enum OrderedRoomType {
  living_dining_room,
  bedroom,
  kitchen,
  bathroom,
  floor_plan,
  unknown,
}

export const remapPriorityMedia = (
  mediaItem: Potential_Property_Media
): Potential_Property_Media & { isPrimary: boolean; roomTypeOrder: number } => {
  return {
    ...mediaItem,
    isPrimary: false,
    roomTypeOrder: mediaItem.roomType ? OrderedRoomType[mediaItem.roomType] : OrderedRoomType.unknown,
  }
}

export const parsePotentialPropertyMedia = (potentialPropertyMedia: Potential_Property_Media[]): PriorityMedia => {
  const floorPlanFiltered = potentialPropertyMedia.filter((item) => item?.imageCategory === 'floorPlan')
  const floorPlan = pipe(floorPlanFiltered, A.map(floorPlanType.decode), A.rights)
  const sorted = potentialPropertyMedia
    .filter((item) => item.imageCategory !== 'floorPlan')
    .map(remapPriorityMedia)
    .sort((a, b) => {
      if (a.roomTypeOrder === b.roomTypeOrder) {
        const roomTypeConfidenceA = a.roomTypeConfidence ?? 0
        const roomTypeConfidenceB = b.roomTypeConfidence ?? 0
        return roomTypeConfidenceB - roomTypeConfidenceA
      }
      return a.roomTypeOrder - b.roomTypeOrder
    })
    .map(({ isPrimary, url }) => ({
      isPrimary,
      url,
    }))

  const photoGallery = pipe(sorted, A.map(cardPhotos.decode), A.rights)
  return { floorPlan, photoGallery }
}
